import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { StyledAnswerWithFeedback } from './AnswerWithFeedback.styled';
import Image from 'next/image';

export default function AnswerWithFeedback({ answer, correctAnswer }) {
  const isCorrect = answer?.id == correctAnswer?.id;
  return (
    <StyledAnswerWithFeedback className="answer-with-feedback-container">
      <div className="answer-with-feedback">
        <span className="label">Your answer:</span>
        <div className="img-container">
          {answer ? (
            <Image
              src={answer.image}
              alt={answer.id}
              width={1280}
              height={720}
              layout="responsive"
              objectFit="contain"
            />
          ) : (
            <div className="img-placeholder error">
              <Image
                src={
                  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
                  '/commonGameAssets/realTime/drag-here-placeholder.png'
                }
                alt=""
                width={700}
                height={394}
                objectFit="contain"
              />
              <span className="absolute-centered">
                <CloseCircleOutlined />
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="correct-answer">
        {!isCorrect ? (
          <>
            <span className="label">Correct answer:</span>
            <div className="img-container">
              <Image
                src={correctAnswer.image}
                alt={correctAnswer.id}
                width={1280}
                height={720}
                layout="responsive"
                objectFit="contain"
              />
            </div>
          </>
        ) : (
          <div className="img-container">
            <div className="img-placeholder success">
              <Image
                src={
                  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
                  '/commonGameAssets/realTime/drag-here-placeholder.png'
                }
                alt=""
                width={700}
                height={394}
                objectFit="contain"
              />
              <span className="absolute-centered last-correct">
                <CheckCircleOutlined />
              </span>
            </div>
          </div>
        )}
      </div>
    </StyledAnswerWithFeedback>
  );
}
